function makeCreatePlayer ({ Howl, Howler }) {
  return function createPlayer (settings) {
    const player = new Howl(settings);

    const play = player.play.bind(player);
    let lastPlay;

    player.play = function (...args) {
      try {
        if (Howler && Howler.ctx && Howler.ctx.state === 'suspended') {
          return null;
        }
      } catch (e) {}
      if (lastPlay) {
        this.stop(lastPlay);
      }
      lastPlay = play(...args);
      return lastPlay;
    };

    return player;
  };
}

export { makeCreatePlayer };
